import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../common/_services/auth/auth.service";
import { JsonErrorMessagesService } from "../shared/_services/json-error-messages/json-error-messages.service";
import { Register } from "../common/_models/register/register";
import { DcValidation } from "../shared/_validation/dc-validation";
import { AlertifyService } from "../shared/_services/alertify/alertify.service";

@Component({
  selector: "app-auth-register",
  templateUrl: "./auth-register.component.html",
  styleUrls: ["./auth-register.component.css"]
})
export class AuthRegisterComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    private authService: AuthService,
    private alertify: AlertifyService,
    private jsonErrorMessagesService: JsonErrorMessagesService
  ) {}

  // #region declear
  form: FormGroup;

  registerObject = {} as Register;

  formErrors = {};

  validationMessages;

  errorMessages: any[] = [];

  mapFormValues() {
    this.registerObject.username = this.form.value.username;
    this.registerObject.email = this.form.value.email;
    this.registerObject.password = this.form.value.password;
    this.registerObject.confirmPassword = this.form.value.confirmPassword;
  }
  // #endregion

  ngOnInit() {
    this.jsonErrorMessagesService.getJSON().subscribe(messages => {
      this.validationMessages = messages.register;
    });
    this.form = this.fb.group(
      {
        username: ["", [Validators.required, Validators.minLength(6)]],
        email: ["", [Validators.required, Validators.email]],
        password: [
          "",
          [
            Validators.required,
            Validators.minLength(6),
            DcValidation.passwordValidatorHasLower,
            DcValidation.passwordValidatorHasNumber,
            DcValidation.passwordValidatorHasUpper,
            DcValidation.passwordValidatorHasSpecialCharacter
          ]
        ],
        confirmPassword: [""]
      },
      {
        validator: DcValidation.MatchPassword // your validation method
      }
    );

    this.form.valueChanges.subscribe(data => {
      this.errorMessages = DcValidation.logValidationErrors(
        this.form,
        this.formErrors,
        this.validationMessages,
        this.errorMessages
      );
    });
  }

  register() {
    this.spinner.show();
    this.mapFormValues();
    this.authService.register(this.registerObject).subscribe(
      () => this.alertify.success("Please check your email"),
      err => {
        this.alertify.error("Email address is already registered");
        this.spinner.hide();
      },
      () => {
        this.spinner.hide(); 
        this.router.navigate(["/login"]);
      }
    );
  }
}
